import { ACTION_LOGOUT } from "app/modules/login/reducer/actions.type";
import {
  SET_TRANS_HISTORY,
  SET_TRANS_HISTORY_RESET,
  FETCH_TRANS_HISTORY_REQUEST,
  FETCH_TRANS_HISTORY_SUCCESS,
  FETCH_TRANS_HISTORY_FAILURE,
  FETCH_TRANS_HISTORY_BACKUP_REQUEST,
  FETCH_TRANS_HISTORY_BACKUP_SUCCESS,
  FETCH_TRANS_HISTORY_BACKUP_FAILURE,
} from "./actions.type";

import { TransHistoryState, TransHistoryActions } from "./types";

const initialState: TransHistoryState = {
  transHistory: undefined,
  responseTransHistory: undefined,
  pending: false,
};

export default (state = initialState, action: TransHistoryActions): TransHistoryState => {
  switch (action.type) {
    case SET_TRANS_HISTORY:
      return {
        ...state,
        ...action.payload,
      };
    case FETCH_TRANS_HISTORY_REQUEST:
      return {
        ...state,
        pending: true,
        responseTransHistory: undefined,
        transHistory: action.payload,
      };
    case FETCH_TRANS_HISTORY_SUCCESS:
      return {
        ...state,
        pending: false,
        responseTransHistory: action.payload,
      };
    case FETCH_TRANS_HISTORY_FAILURE:
      return {
        ...state,
        pending: false,
      };
    case FETCH_TRANS_HISTORY_BACKUP_REQUEST:
      return {
        ...state,
        pending: true,
        transHistory: action.payload,
      };
    case FETCH_TRANS_HISTORY_BACKUP_SUCCESS:
      return {
        ...state,
        pending: false,
      };
    case FETCH_TRANS_HISTORY_BACKUP_FAILURE:
      return {
        ...state,
        pending: false,
      };
    case SET_TRANS_HISTORY_RESET:
      return {
        ...state,
        transHistory: undefined,
        responseTransHistory: undefined,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
